import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ReactQuill from "react-quill";
import { Link, useParams } from "react-router-dom";
import { API_BASE_URL, Image_URL } from "../config";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useCurrency } from "../context/CurrencyContext";

const Customiseorderlist = () => {
  const { userId, orderId } = useParams();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { selectedCurrency } = useCurrency();
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState("");
  const [editorData, setEditorData] = useState("");
  const [originalDescription, setOriginalDescription] = useState("");
  const [categories, setCategories] = useState([]);
  const [AustralianSize, setAustralianSize] = useState([]);
  const [metals, setMetals] = useState([]);
  const [metalPurityTypes, setMetalPurityTypes] = useState([]);
  const [diamondQualities, setDiamondQualities] = useState([]);
  const [diamondType, setdiamondType] = useState([]);
  const [diamondColours, setdiamondcolour] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedsize, setselectedsize] = useState([]);
  const [selectedMetal, setSelectedMetal] = useState("");
  const [selectedMetalpurityType, setselectedMetalPurityTypes] = useState([]);
  const [selecteddiamondQuality, setselecteddiamondQuality] = useState([]);
  const [selecteddiamondType, setselecteddiamondType] = useState([]);
  const [selecteddiamondColourid, setselecteddiamondColour] = useState([]);

  //const [stoneColor, setStoneColor] = useState("");
  const [diamondCarat, setDiamondCarat] = useState("");
  const [finding, setFinding] = useState("");
  const [engraving, setEngraving] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [ReferenceNo, setReferenceNo] = useState("");
  const [StaffName, setStaffName] = useState("");
  const [RefCustomerName, setRefCustomerName] = useState("");


  const [file, setFile] = useState([]);
  const [file1, setFile1] = useState([]);
  const [editingProductId, setEditingProductId] = useState(null);
  const [editingstage, setStage] = useState(null);
  //const descriptionRef = useRef(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null); // Store clicked image
  const [showPopup, setShowPopup] = useState(false); // Manage popup visibility
  const [filterCategoryName, setfilterCategoryName] = useState("");
  const [filteredSizes, setFilteredSizes] = useState([]);
  const [requirements, setRequirements] = useState([""]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeView, setActiveView] = useState(localStorage.getItem("activeView") || "wholesale");

   useEffect(() => {
  const handleStorageChange = () => {
    const newView = localStorage.getItem("activeView") || "wholesale";
    setActiveView(newView);
  };

  window.addEventListener("storage", handleStorageChange);

  return () => {
    window.removeEventListener("storage", handleStorageChange);
  };
}, []);
  const fetchOrderDetails = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/Customised/GetProductCustomizationDetails?userId=${userId}&orderId=${orderId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch order details.");
      }
      const data = await response.json();
      setOrders(Array.isArray(data) ? data : []); // Ensure data is an array
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [userId, orderId]);

  const fetchCategories = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetCustomisedCategory`);
      if (!response.ok) throw new Error("Failed to fetch categories");
      const result = await response.json();
      setCategories(Array.isArray(result.data) ? result.data : []);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    }
  }, []);



  const fetchsize = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetSizeSubCategory`);
      const result = await response.json();

      if (Array.isArray(result.data)) {
        setAustralianSize(result.data);
      } else {
        console.error("Expected an array, but got:", result.data);
        setAustralianSize([]); // Default to an empty array to prevent crashes
      }
    } catch (error) {
      console.error("Error fetching stones color :", error);
    }
  }, []);

  const fetchMetals = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetMetal`);
      if (!response.ok) throw new Error("Failed to fetch metals");
      const result = await response.json();
      setMetals(Array.isArray(result.data) ? result.data : []);
    } catch (error) {
      console.error("Error fetching metals:", error);
      setMetals([]);
    }
  }, []);


  const fetchMetalPurityTypes = useCallback(async (metalId) => {
    if (!metalId) {
      setMetalPurityTypes([]); // Clear purity types when no metal is selected
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetMetalCaret?metalid=${metalId}`);
      const result = await response.json();
      setMetalPurityTypes(result.data || []);
    } catch (error) {
      console.error("Error fetching metal purity types:", error);
    }
  }, []);
  const fetchDiamondType = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetDiamond`);
      const result = await response.json();
      setdiamondType(result.data || []);
    } catch (error) {
      console.error("Error fetching diamond qualities:", error);
    }
  }, []);

  const fetchDiamondQualities = useCallback(async (diamondid) => {
    if (!diamondid) {
      setDiamondQualities([]);
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetClaritys?Diamondid=${diamondid}`);
      const result = await response.json();
      setDiamondQualities(result.data || []);
    } catch (error) {
      console.error("Error fetching diamond qualities:", error);
    }
  }, []);

  const fetchDiamondcolour = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetDiamondColours`);
      const result = await response.json();
      setdiamondcolour(result.data || []);
    } catch (error) {
      console.error("Error fetching diamond qualities:", error);
    }
  }, []);



  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
    fetchCategories();
    fetchMetals();
    fetchDiamondQualities();
    fetchsize();
    fetchDiamondType();
    fetchDiamondcolour();
  }, []);




  useEffect(() => {
    let categoryToFilter = filterCategoryName || categories.find(cat => cat.id === Number(selectedCategory))?.name;

    if (categoryToFilter) {
      // Filter sizes based on the selected category name
      const filtered = AustralianSize.filter(item => item.category === categoryToFilter);

      setFilteredSizes(filtered);

    } else {
      setFilteredSizes([]);
    }
  }, [selectedCategory, filterCategoryName, AustralianSize, categories]);

  if (loading) return <p>Loading order details...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!orders.length) return <p>No order details available.</p>;



  const handleConfirmAccept = (product) => {
    const isConfirmed = window.confirm("Are you sure you want to accept this product?");
    if (isConfirmed) {
      handleAccept(product);
    }
  };

  const handleAccept = async (product) => {
    try {
      const requestBody = {
        Id: product.id,
        CreatedBy: "Customer",
        Stage: 'Order Approved by Retailer',
        Status: "Order Approved by Retailer" + product.partnerName,
      };

      const formData = new FormData();
      formData.append("modelJson", JSON.stringify(requestBody));

      const response = await fetch(`${API_BASE_URL}/Customised/AcceptProduct`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Product accepted successfully!");
        fetchOrderDetails();
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Error accepting product:", error);
      alert("An error occurred while accepting the product.");
    }
  };

  const handleConfirmCencal = (product) => {
    const isConfirmed = window.confirm("Are you sure you don't want to proceeding with this product.?");
    if (isConfirmed) {
      handleCencal(product);
    }
  };

  const handleCencal = async (product) => {
    try {
      const requestBody = {
        Id: product.id,
        CreatedBy: "Customer",
        Stage: "Not Proceeding",
        Status: "Not Proceeding by Retailer" + product.partnerName,
      };

      const formData = new FormData();
      formData.append("modelJson", JSON.stringify(requestBody));

      const response = await fetch(`${API_BASE_URL}/Customised/AcceptProduct`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Product accepted successfully!");
        fetchOrderDetails();
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Error accepting product:", error);
      alert("An error occurred while accepting the product.");
    }
  };


  // Handle category change
  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setfilterCategoryName(""); // Reset filter name since user manually selects category
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const inputId = event.target.id;

    let allowedExtensions = [];

    if (inputId === "UploadImage") {
      allowedExtensions = [".jpg", ".jpeg", ".png"];
    } else if (inputId === "UploadImage1") {
      allowedExtensions = [".jcd", ".3dm", ".stl", ".pdf"];
    }

    const invalidFiles = selectedFiles.filter(file => {
      const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
      return !allowedExtensions.includes(ext);
    });

    if (invalidFiles.length > 0) {
      alert("Invalid file type(s) detected. Please upload only: " + allowedExtensions.join(", ").toUpperCase());
      event.target.value = ""; // Clear the input
      return;
    }

    // Set files if validation passes
    if (inputId === "UploadImage") {
      setFile(selectedFiles);
    } else if (inputId === "UploadImage1") {
      setFile1(selectedFiles);
    }
  };

  const handleRequirementChange = (index, value) => {
    const newRequirements = [...requirements];
    newRequirements[index] = value;
    setRequirements(newRequirements);
  };

  const handleAddRequirement = () => {
    setRequirements([...requirements, ""]);
  };

  const handleRemoveRequirement = (index) => {
    const newRequirements = [...requirements];
    newRequirements.splice(index, 1);
    setRequirements(newRequirements);
  };


  const CountryName = "AU";
  const handleSubmit = async () => {
    setIsSubmitting(true);
    const productData = {
      Id: editingProductId || null,
      CategoryId: selectedCategory || 101,
      MetalId: selectedMetal || 101,
      MetalCaretId: selectedMetalpurityType || 101,
      QualityId: selecteddiamondQuality || 101,
      DiamondId: selecteddiamondType || 101,
      SizeId: selectedsize || 101,
      Carat: diamondCarat || 0,
      StoneColor: "",//stoneColor,
      Finding: finding,
      Engraving: engraving,
      DeliveryDate: deliveryDate,
      ProductDescription: editorData?.trim() || originalDescription,
      Stage: editingstage,
      CreatedBy: "Customer",
      Status: "Updated",
      UserID: userId,// user.id,
      ReferenceNo: ReferenceNo,
      RefcustomerName: RefCustomerName,
      DiamondColourid: selecteddiamondColourid,
      StaffName: StaffName,
      Requirements: requirements.filter(r => r.trim() !== ""),
      Country: "AU",
      ActionType: editingProductId ? "UPDATE" : "INSERT",
    };

    const formData = new FormData();
    formData.append("modelJson", JSON.stringify(productData));

    if (file && file.length > 0) {
      file.forEach((f) => formData.append("UploadImage", f));
    }

    if (file1 && file1.length > 0) {
      file1.forEach((f) => formData.append("UploadImage1", f));
    }

    try {
      const response = await fetch(`${API_BASE_URL}/Customised/InsertProductCustomizationBYPartener`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      alert(result.message || "Product saved successfully!");
      clearForm();
      await fetchOrderDetails();
      setShowModal(false);

    } catch (error) {
      console.error("Error saving product:", error);
    }
    finally {
      setIsSubmitting(false); // re-enable button
    }
  };

  // Populate Form for Editing
  const handleEdit = (order) => {


    setSelectedOrder(order);  // Store the selected order
    setEditingProductId(order.id);
    setfilterCategoryName(order.categoryName);// Store category name  
    setSelectedCategory(order.categoryId);
    setselectedsize(order.sizeId);
    setSelectedMetal(order.metalId);

    // Fetch metal purity types when metal is selected
    fetchMetalPurityTypes(order.metalId).then(() => {
      setselectedMetalPurityTypes(order.metalCaretId);
    });
    setselecteddiamondType(order.diamondId);
    fetchDiamondQualities(order.diamondId).then(() => {
      setselecteddiamondQuality(order.qualityId);
    });
    //setselecteddiamondQuality(order.qualityId);

    setselecteddiamondColour(order.diamondColourid)
    //setStoneColor(order.stoneColor);
    setFinding(order.finding);
    setEngraving(order.engraving);
    setDiamondCarat(order.carat);
    setDeliveryDate(order.deliveryDate ? order.deliveryDate.split("T")[0] : "");

    setOriginalDescription(order.productDescription || "");
    setEditorData("");
    setReferenceNo(order.referenceNo);

    setStaffName(order.staffName);
    setRefCustomerName(order.refcustomerName);
    setStage(order.stage);
    setShowModal(true);
  };


  const clearForm = () => {
    setEditingProductId(null);
    setSelectedCategory("");
    setSelectedMetal("");
    setselectedMetalPurityTypes("");
    //setStoneColor("");
    setDiamondCarat("");
    setselecteddiamondType("");
    setFinding("");
    setEngraving("");
    setEditorData("");
    setReferenceNo("");
    setStaffName("");
    setRefCustomerName("");
    setStage("");
    setFile(null);
    setFile1(null);
  };



  const openPopup = (imageUrl) => {
    setSelectedImage(imageUrl);

    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedImage([]);  // Reset to empty array
  };

  const downloadAllImages = async (images, OrdersID) => {
    if (!images || images.length === 0) {
      alert("No files to download.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/Download/DownloadImagesZip`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(images)  // just list of file names like ["file1.jcd", "file2.3dm"]
      });

      if (!response.ok) {
        throw new Error("Failed to download files.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Order_${OrdersID}_Images.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading zip:", error);
      alert("Download failed. Please try again.");
    }
  };

  function reconstructFilenames(rawString) {
    const parts = rawString.split(',').map(p => p.trim()).filter(p => p);
    const knownExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'pdf', 'stl', '3dm', 'jcd', 'bmp'];

    const reconstructed = [];
    let currentFile = '';

    for (let i = 0; i < parts.length; i++) {
      if (currentFile) currentFile += ', ' + parts[i]; // add comma and next part
      else currentFile = parts[i];

      const ext = currentFile.split('.').pop().toLowerCase();
      if (knownExtensions.includes(ext)) {
        reconstructed.push(currentFile.trim());
        currentFile = '';
      }
    }

    // Add any leftover part
    if (currentFile) reconstructed.push(currentFile.trim());

    return reconstructed;
  }


  return (
    <div className="home">
      <div id="page" className="hfeed page-wrapper">
        <Header />
        <div id="site-main" className="site-main">
          <div id="main-content" className="main-content">
            <div id="primary" className="content-area">
              <div id="content" className="site-content" role="main">
                <div className="section-padding">
                  <div className="section-container p-l-r">
                    <div className="tab-container">
                      <div className="tab-header" id="customTabHeader">

                        <h2 className="text-center">  <Link to="/customiseorder" style={{ color: "black" }} className="btn btn-view"> <i className="fa fa-arrow-left" aria-hidden="true"></i></Link>Existing Custom Order Details</h2>
                      </div>
                      <div className="tab-content active" id="orders">


                        {orders?.map((order, index) => {
                          const formatDateTime = (date) => {
                            return date
                              ? new Date(date).toLocaleString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                              })
                              : "-";
                          };



                          const partnerTime = order.modifiedBy === "Customer" ? formatDateTime(order.modifiedOn) : "-";
                          const adminTime = order.modifiedBy === "Admin" ? formatDateTime(order.modifiedOn) : "-";

                          const showPartnerFirst = order.modifiedBy === "Customer" && order.modifiedOn >= order.modifiedOn;

                          // const images = [
                          //   ...(order.attachment ? order.attachment.split(",") : []),
                          //   ...(order.partnerAttachment ? order.partnerAttachment.split(",") : [])
                          // ].filter(img => img && img.trim() !== "");

                          const images = [
                            ...reconstructFilenames(order.attachment || ''),
                            ...reconstructFilenames(order.partnerAttachment || '')
                          ].filter(img => img && img.trim() !== '');

                          console.log('images', images);

                          return (
                            <div key={index} className="order-info-container">
                              <div className="info-above" style={{ backgroundColor: order.modifiedBy === "Customer" ? "orange" : "lightblue" }}>
                                <div className="placed">
                                  <p>Order ID</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.country}-{order.id}</p>
                                </div>
                                <div className="placed">
                                  <p>Staff Name</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.staffName}</p>
                                </div>
                                <div className="placed">
                                  <p>Customer Name</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.partnerName}</p>
                                </div>

                                <div className="placed">
                                  <p>Order Reference</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.referenceNo}</p>
                                </div>
                                <div className="placed">
                                  <p>Reference Customer Name</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.refcustomerName}</p>
                                </div>
                                <div className="order-total">
                                  <p>Quality</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.quality}</p>
                                </div>
                                <div className="order-id">
                                  <p>Carat</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.carat}</p>
                                </div>
                                <div className="order-id">
                                  <p>Size</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>{order.size}</p>
                                </div>
                                {activeView === "wholesale" && (
                                <div className="placedby">

                                  <p>Amount</p>
                                  <p style={{ fontWeight: "bold", color: "#565656" }}>
                                   {(() => {
                                      const amount = parseFloat(order.amount) || 0;
                                     const compString = user?.businessCompensation || "0%";
                                      const compValue = parseFloat(compString.replace("%", "")) || 0; 
                                      const finalAmount = amount + (amount * compValue) / 100;
                                      return `$${finalAmount.toFixed(0)}`;
                                    })()}

                                     {/* {(() => {
  const amount = parseFloat(order.amount) || 0;

  // convert amount based on selected currency rate
  const currencyRate = parseFloat(selectedCurrency?.price) || 1;
  const convertedAmount = amount * currencyRate;

  const compString = user?.businessCompensation || "0%";
  const compValue = parseFloat(compString.replace("%", "")) || 0;

  const finalAmount = convertedAmount + (convertedAmount * compValue) / 100;

  const currency =
    selectedCurrency?.name === "GBP"
      ? selectedCurrency?.name
      : `${selectedCurrency?.name} $`;

  return `${currency} ${finalAmount.toFixed(0)}`;
})()} */}
                                  </p>
                                  {/* <p style={{ fontWeight: "bold", color: "#565656" }}>
                                    ${order.amount ? order.amount.toFixed(2) : "0.00"}
                                  </p> */}
                                </div>
                        )}
                                <div className="order-status">
                                  {order.stage === "Pending" ? (
                                    <>
                                      <button onClick={() => handleConfirmCencal(order)} className="btn btn-primary">
                                        Not Proceeding
                                      </button>
                                    </>
                                  ) : (
                                    ["Inquiry Accepted", "CAD Design Submitted", "Update Delivery Date"].includes(order.stage) ? (
                                      <>
                                        <button onClick={() => handleConfirmAccept(order)} className="btn btn-primary">
                                          Approve Order
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <p></p>
                                        <p>
                                          <b style={{ color: "blue", textAlign: "center" }}>
                                            {["order approved by retailer", "order in production"].includes(order.stage.toLowerCase().trim()) ? order.stage : null}
                                          </b>
                                        </p>
                                      </>
                                    )
                                  )}
                                  {/* {index === 0 && 
  ["Inquiry Accepted", "CAD Design Submitted", "Update Delivery Date"].includes(order.stage) ? (
    <button onClick={() => handleConfirmAccept(order)} className="btn btn-primary">
      Approve Order
    </button>
) : (
  <>
<p></p>
<p>
    <b style={{ color: "blue", textAlign: "center" }}>
        {["order approved by retailer", "order in production"].includes(order.stage.toLowerCase().trim()) ? order.stage : null}
    </b>
</p>
  </> 
)} */}


                                </div>
                                <div className="order-status">
                                  {/* && order.stage !== "Delivered" */}
                                  {/* {index === 0  && (
                                    <button className="btn btn-primary" onClick={() => handleEdit(order)}>
                                      Reply
                                    </button>
                                  )} */}
                                  <button className="btn btn-primary" onClick={() => handleEdit(order)}>
                                    Reply
                                  </button>
                                </div>
                              </div>
                              <hr />
                              <div key={index} className="order-info-container">
                                <div className="info-middle">
                                  {/* {images.map((img, index) => (
                                    <img
                                      key={index}
                                      src={`${Image_URL}product/${encodeURIComponent(img.trim())}`}
                                      alt={`Product ${index + 1}`}
                                      className="expanded-product-image"
                                      style={{ width: "160px", objectFit: "cover", cursor: "pointer" }}
                                      onClick={() => openPopup(img)}
                                    />
                                   
                                  ))} */}

                                  {images.map((img, index) => {
                                    console.log("Full images array:", images);
                                    console.log("Original img value:", img);
                                    const fileName = img.trim();
                                    const fileUrl = `${Image_URL}product/${encodeURIComponent(fileName)}`;
                                    const fileExtension = fileName.split('.').pop().toLowerCase();

                                    const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileExtension);
                                    const isPdf = fileExtension === "pdf";
                                    const isStl = fileExtension === "stl";
                                    const is3dm = fileExtension === "3dm";
                                    const isJcd = fileExtension === "jcd";

                                    return (
                                      <div key={index} style={{ display: "inline-block", margin: "10px", textAlign: "center" }}>
                                        {isImage ? (
                                          <img
                                            src={fileUrl}
                                            alt={`Product ${index + 1}`}
                                            className="expanded-product-image"
                                            style={{ width: "160px", height: "160px", objectFit: "cover", cursor: "pointer" }}
                                            onClick={() => openPopup(img)}
                                          />
                                        ) : isPdf ? (
                                          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
                                            <i className="fa fa-file-pdf-o" style={{ fontSize: "80px", color: "red", cursor: "pointer" }}></i>
                                            <div style={{ fontSize: "12px" }}>PDF File</div>
                                          </a>
                                        ) : isStl ? (
                                          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
                                            <i className="fa fa-cube" style={{ fontSize: "80px", color: "blue", cursor: "pointer" }}></i>
                                            <div style={{ fontSize: "12px" }}>STL 3D File</div>
                                          </a>
                                        ) : is3dm ? (
                                          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
                                            <i className="fa fa-cube" style={{ fontSize: "80px", color: "green", cursor: "pointer" }}></i>
                                            <div style={{ fontSize: "12px" }}>3DM 3D File</div>
                                          </a>
                                        ) : isJcd ? (
                                          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
                                            <i className="fa fa-cube" style={{ fontSize: "80px", color: "purple", cursor: "pointer" }}></i>
                                            <div style={{ fontSize: "12px" }}>JCD 3D File</div>
                                          </a>
                                        ) : (
                                          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
                                            <i className="fa fa-file-o" style={{ fontSize: "80px", color: "gray", cursor: "pointer" }}></i>
                                            <div style={{ fontSize: "12px" }}>File</div>
                                          </a>
                                        )}
                                      </div>
                                    );
                                  })}


                                  <button onClick={() => downloadAllImages(images, order.id)} className="btn btn-info">Download Images</button>
                                </div>

                              </div>
                              <hr />
                              <div className="info-below">
                                <div className="img-and-info">
                                  <div>
                                    <div className="delivery-status">
                                      <h4>Status</h4>
                                      <h6>{order.stage}</h6>
                                    </div>
                                  </div>
                                  <div className="order-status-content">
                                    {showPartnerFirst ? (

                                      <>
                                        <div>
                                          <p>Customer Modified Date : <label style={{ fontWeight: "bold", color: "#565656" }}>{partnerTime ? partnerTime.toLocaleString() : "-"}</label></p>
                                          <p>Customer Description :   <label style={{ margin: "0px 0 15px" }} dangerouslySetInnerHTML={{ __html: order.productDescription || "-", }}></label>
                                          </p>
                                        </div>
                                        <br></br>
                                        <div>
                                          <p>Admin Modified Date :  <label style={{ fontWeight: "bold", color: "#565656" }}>{adminTime ? adminTime.toLocaleString() : "-"}</label></p>
                                          <p>Admin Comments :   <label style={{ fontWeight: "bold", color: "#565656" }} dangerouslySetInnerHTML={{ __html: order.comments || "-", }}></label>

                                            {/* <p>Admin Comments:<label style={{ fontWeight: "bold", color: "#565656" }}>{order.comments || "-"}</label> */}
                                          </p>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div>
                                          <p>Admin Modified Date :  <label style={{ fontWeight: "bold", color: "#565656" }}>{adminTime ? adminTime.toLocaleString() : "-"}</label></p>
                                          <p>  Admin Comments:  <label style={{ fontWeight: "bold", color: "#565656" }} dangerouslySetInnerHTML={{ __html: order.comments || "-" }}></label></p>
                                        </div>
                                        <br></br>
                                        <div>
                                          <p>Customer Modified Date : <label style={{ fontWeight: "bold", color: "#565656" }}>{partnerTime ? partnerTime.toLocaleString() : "-"}</label></p>

                                          <p>Customer Description : <label style={{ margin: "0px 0 15px" }} dangerouslySetInnerHTML={{ __html: order.productDescription || "-", }}></label></p>
                                        </div>
                                      </>
                                    )}
                                    <div className="placed">
                                      <p>Requirement</p>
                                      {(() => {
                                        let requirementviews = [];

                                        try {
                                          requirementviews = JSON.parse(order.requirement || "[]");
                                        } catch (e) {
                                          requirementviews = [order.requirement || "-"];
                                        }

                                        return requirementviews.map((req, idx) => (
                                          <p key={idx} style={{ fontWeight: "bold", color: "#565656" }}>
                                            {req}
                                          </p>
                                        ));
                                      })()}
                                    </div>
                                    <div className="info-above">

                                      <div className="placed">
                                        <p>Created On</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                                          {order.createdOn ? new Date(order.createdOn).toLocaleDateString() : "-"}
                                        </p>
                                      </div>
                                      <div className="placed">
                                        <p>Customer Delivery Date</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                                          {order.deliveryDate ? new Date(order.deliveryDate).toLocaleDateString() : "-"}
                                        </p>
                                      </div>
                                      <div className="placed">
                                        <p>Admin Delivery Date</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                                          {order.approxDeliveryDays &&
                                            new Date(order.approxDeliveryDays).getFullYear() === 1900
                                            ? "-"
                                            : new Date(order.approxDeliveryDays).toLocaleDateString()}
                                        </p>
                                      </div>
                                      <div className="placed">
                                        <p>Category Name</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.categoryName}</p>
                                      </div>
                                      <div className="placed">
                                        <p>Metal Name</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.metalName}</p>
                                      </div>

                                      <div className="placed">
                                        <p>Metal Purity</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.metalCaretName}</p>
                                      </div>
                                      <div className="placed">
                                        <p>Diamond Type</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.diamondType}</p>
                                      </div>

                                      <div className="placed">
                                        <p>Finding</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.finding}</p>
                                      </div>
                                      <div className="placed">
                                        <p>Engraving</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.engraving}</p>
                                      </div>
                                    </div>
                                    <hr></hr>
                                    <div className="info-above">
                                      <div className="placed">
                                        <p>Diamond Colour</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.diamondColour}</p>
                                      </div>
                                      <div className="placed">
                                        <p>Approx Metal Weight</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.approxMetalWeight}</p>
                                      </div>

                                      <div className="placed">
                                        <p>Dispatch Through</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.dispatchThrough}</p>
                                      </div>
                                      <div className="placed">
                                        <p>Dispatch Date</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                                          {order.dispatchDate &&
                                            new Date(order.dispatchDate).getFullYear() === 1900
                                            ? "-"
                                            : new Date(order.dispatchDate).toLocaleDateString()}</p>
                                      </div>
                                      <div className="placed">
                                        <p>Tracking ID</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.trackingId}</p>
                                      </div>
                                      <div className="placed">
                                        <p>Created By</p>
                                        <p style={{ fontWeight: "bold", color: "#565656" }}>{order.createdBy}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {showPopup && selectedImage.length > 0 && (
        <div className="productimg-expand-popup-overlay">
          <div className="productimg-expand-popup-content">
            {/* <span className="close-popup" onClick={closePopup}>&times;</span> */}
            <button className="close-popup" onClick={closePopup}>Close</button>
            <div className="expanded-images-container">

              <img
                src={`${Image_URL}/product/${selectedImage}`}
                alt={`Expanded Product`}
                className="expanded-product-image"
                style={{ margin: "5px", objectFit: "cover", width: "auto" }}
              />
            </div>
          </div>
        </div>
      )}



      {showModal && selectedOrder && (

        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Customise Product</h5>
                <button type="button" className="close" onClick={() => setShowModal(false)}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-4">
                    <label>Staff Name</label>
                    <input type="text" id="StaffName" name="StaffName" className="form-control" value={StaffName} onChange={(e) => setStaffName(e.target.value)} />

                  </div>
                  <div className="col-md-4">
                    <label>Order Reference</label>
                    <input type="text" id="ReferenceNo" name="ReferenceNo" className="form-control" value={ReferenceNo} onChange={(e) => setReferenceNo(e.target.value)} />

                  </div>
                  <div className="col-md-4">
                    <label>Reference Customer Name</label>
                    <input type="text" id="RefCustomerName" name="RefCustomerName" className="form-control" value={RefCustomerName} onChange={(e) => setRefCustomerName(e.target.value)} />
                  </div>

                </div>
                <div className="row">


                  <div className="col-lg-6">
                    <div className="form-group">
                      <label><span style={{ color: "red" }}>*</span>Category</label>
                      <select className="form-control" value={selectedCategory} onChange={handleCategoryChange}>
                        <option value="">Select Category</option>
                        {categories.map((cat) => (
                          <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label><span style={{ color: "red" }}>*</span> Size</label>
                    {/* <select className="form-control" name="size" value={selectedsize} onChange={(e) => setselectedsize(e.target.value)}>
                      <option value="">Select Size</option>
                     
                      {filteredSizes.map((item) => (
                        <option key={item.id} value={item.id}>
                          {categories.find(cat => cat.id === Number(selectedCategory))?.name === "Rings" ? item.sizeAU : item.displayName}
                        </option>
                      ))}
                    </select> */}
                    <select
                      className="form-control"
                      name="size"
                      value={selectedsize}
                      onChange={(e) => setselectedsize(e.target.value)}
                    >
                      {
                        filteredSizes.length === 0 ? (
                          <option value="NA">NA</option>
                        ) : (
                          <>
                            <option value="Select Size">Select Size</option>
                            {filteredSizes.map((item) => (
                              <option key={item.id} value={item.id}>
                                {categories.find(cat => cat.id === Number(selectedCategory))?.name === "Rings"
                                  ? item.sizeAU
                                  : item.displayName}
                              </option>
                            ))}
                          </>
                        )
                      }
                    </select>

                  </div>

                </div>
                <div className="row mt-3">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label><span style={{ color: "red" }}>*</span>Metal</label>
                      <select
                        className="form-control"
                        value={selectedMetal}
                        onChange={(e) => {
                          const metalId = e.target.value;
                          setSelectedMetal(metalId);
                          fetchMetalPurityTypes(metalId);
                        }}
                      >
                        <option value="">Select Metal</option>
                        {metals.map((metal) => (
                          <option key={metal.id} value={metal.id}>{metal.metalname}</option>
                        ))}
                      </select>

                    </div>
                  </div>
                  <div className="col-md-6">
                    <label><span style={{ color: "red" }}>*</span>Metal Purity Type</label>
                    <select className="form-control" value={selectedMetalpurityType} onChange={(e) => setselectedMetalPurityTypes(e.target.value)}>
                      <option value="">Select Purity Type</option>
                      {metalPurityTypes.map((item) => (
                        <option key={item.id} value={item.id}>{item.displayname}</option>
                      ))}
                    </select>
                  </div>

                </div>

                <div className="row mt-3">
                  <div className="col-md-4">
                    <label><span style={{ color: "red" }}>*</span>Diamond Type</label>
                    <select className="form-control" name="diamondType" value={selecteddiamondType}
                      onChange={(e) => {
                        const diamonId = e.target.value;
                        setselecteddiamondType(diamonId);
                        fetchDiamondQualities(diamonId);
                      }}
                    >
                      <option value="101">Select Diamond Type</option>
                      {diamondType.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label><span style={{ color: "red" }}>*</span>Diamond Clarity</label>
                    <select className="form-control" name="diamondQuality" value={selecteddiamondQuality} onChange={(e) => setselecteddiamondQuality(e.target.value)}>
                      <option value="101">Select Diamond Clarity</option>
                      {diamondQualities.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>Diamond Colour</label>
                    <select className="form-control" name="diamondColourid" value={selecteddiamondColourid} onChange={(e) => setselecteddiamondColour(e.target.value)}>
                      <option value="101">Select Diamond Colour</option>
                      {diamondColours.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="finding">
                      Finding
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="finding"
                      id="finding"
                      value={finding}
                      onChange={(e) => setFinding(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-field col-md-6">
                    <label>Engraving</label>
                    <input
                      className="form-control"
                      type="text"
                      name="engraving"
                      value={engraving}
                      onChange={(e) => setEngraving(e.target.value)}
                    />
                  </div>
                </div>

              </div>
              <div className="row mt-3">



              </div>

              <div className="row">

                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Diamond Carat</label>
                    <input
                      type="text"
                      id="diamondCarat"
                      name="diamondCarat"
                      className="form-control"
                      value={diamondCarat}
                      onChange={(e) => {
                        let value = e.target.value;

                        // Allow only numbers and at most one '.'
                        value = value.replace(/[^0-9.]/g, '');      // Remove anything except digits and '.'
                        const parts = value.split('.');
                        if (parts.length > 2) {
                          // If multiple '.', keep only first part and first '.'
                          value = parts[0] + '.' + parts[1];
                        }

                        // Set the state with the updated value
                        setDiamondCarat(value);
                      }}
                    />

                    {/* <input type="text" className="form-control" value={diamondCarat} onChange={(e) => setDiamondCarat(e.target.value)} /> */}
                  </div>
                </div>
                <div className="input-field col-md-6">
                  <label><span style={{ color: "red" }}>*</span>Delivery Date</label>
                  <input readOnly
                    className="form-control"
                    type="date"
                    name="deliveryDate"
                    value={deliveryDate}
                    onChange={(e) => setDeliveryDate(e.target.value)}
                    min={new Date().toISOString().split("T")[0]}
                  />

                </div>
              </div>
              <br></br>
              <div className="row mt-3">

                {requirements.map((req, index) => (
                  <>
                    <div key={index} className="d-flex align-items-center mb-2 col-md-10">

                      <input
                        type="text"
                        className="form-control"
                        value={req}
                        onChange={(e) => handleRequirementChange(index, e.target.value)}
                        placeholder={`Requirement ${index + 1}`}
                      />
                      <br></br>
                    </div>

                    <div className="col-md-2">

                      {requirements.length > 1 && (
                        <button
                          type="button"
                          className="btn-danger"
                          onClick={() => handleRemoveRequirement(index)}
                        >
                          -
                        </button>
                      )}
                    </div>
                  </>
                ))}

                {/* Add button shown separately, after the loop */}
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleAddRequirement}
                  >
                    + Add
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label>Product Description</label>
                <ReactQuill theme="snow" value={editorData} onChange={setEditorData} style={{ height: "200px" }} />
              </div>
              <br></br><br></br>
              <div className="form-group">
                {/* <label>Upload Image (JPG / JPEG / JCD / 3DM / STL / pdf and PNG File only)</label>
                <input type="file" className="form-control" onChange={handleFileChange} accept=".jpg, .jpeg, .png, .JCD, .3DM, .STL, .pdf"  multiple />
              */}
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label><span style={{ color: "red" }}>*</span>Upload Image (JPG / JPEG and PNG File only)</label>
                    <input type="file" id="UploadImage" className="form-control" onChange={handleFileChange} accept=".jpg, .jpeg, .png" multiple />
                  </div>
                  <div className="col-md-6">
                    <label>Upload Image (JCD / 3DM / STL / PDF File only)</label>
                    <input type="file" id="UploadImage1" className="form-control" onChange={handleFileChange} accept=".jcd, .3dm, .stl, .pdf" multiple />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {/* <button className="btn btn-primary" onClick={handleSubmit}>Save</button> */}
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Save"}
              </button>
              <button className="btn btn-secondary" onClick={clearForm}>Clear</button>
            </div>
          </div>
        </div>



      )
      }


      {/* CSS for Modal */}
      <style>
        {`
        .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-title{
  font-size: 20px;
  
  }
.modal {
  background: white;
    padding: 20px;
    position: absolute;
    border-radius: 10px;
    /* overflow: scroll; */
    top: 10%;
    left: 20%;
    min-width: 60%;
    z-index: 999999;
    max-width: 100%;
    width: 400px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    
}

.modal-header{
display: flex;
    justify-content: space-between;
    align-items: center;
    }

.btn {
  margin: 5px;
  padding: 8px 15px;
  cursor: pointer;
  border: none;
  color: white;
  font-size: 14px;
  border-radius: 5px;
}
.expanded-images-container{
text-align: center;
}
.btn-primary {
  background: #007bff;
  transition: background 0.3s;
}

.btn-primary:hover {
  background: #0056b3;
}

.btn-danger {
  background: red;
  transition: background 0.3s;
}

.btn-danger:hover {
  background: darkred;
}
/* Overlay Background */
.productimg-expand-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
}

/* Popup Content */
.productimg-expand-popup-content {
  position: relative;
  
  padding: 20px;
  border-radius: 8px;
  max-width: 80%;
  max-height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Expanded Image */
.expanded-product-image {
  max-width: 70%;
  max-height: 100%;
  border-radius: 8px;
}

/* Close Button */
.close-popup {
      position: absolute;
    top: 0px;
    right: 26vh;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    color: black;
}

      `}
      </style>
    </div >
  );
};

export default Customiseorderlist;
